/* eslint-disable @typescript-eslint/no-explicit-any */
import { CategoryModel } from '@mercadoni/sinister/dist/lib/src/entities/category'
import CategoriesLayout from './layout'
import CategoriesLogic from './logic'

interface CategoriesProps {
  className?: string
  initialCategories?: CategoryModel[]
}

const Categories = (props: CategoriesProps) => {
  return <CategoriesLogic Wrapper={CategoriesLayout} {...props} />
}

export default Categories
